export const SCROLL_OFFSET = (36 + 24) * 6
